<template>
  <div>
    <div class="certif-list">
      <div class='img-div' v-for="item in certifs" :key="item.ID">
          <div class='img-block'>
              <img :src="`${ApiService.ImgHost}/${item.CertImg}_150x230.png`" class="imgItem">
          </div>
          <span class="text-clamp1" :title="item.CertName">{{item.CertName}}</span>
      </div>
      <div class="img-div2" v-for="(item, index) in 10" :key="index"></div>
    </div>

    <el-empty description="暂无数据" v-if="certifs.length <= 0"></el-empty>
  </div>
</template>

<script>
import { CertifService, ApiService } from '@/service'

export default {
  data() {
    return {
      certifs: [],
      ApiService,
    }
  },
  mounted() {
    this.certifList();
  },
  methods: {
    async certifList() {
      const res = await CertifService.certifList(this.$route.params.id, 1, 300);
      if (res) {
        this.certifs = res.List || [];
      }
    }
  }
}
</script>

<style lang="less" scoped>
.certif-list{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.img-div2{
  width: 165px;
  height: 1px;
  margin-bottom: 12px;
}
.img-div{
  width: 165px;
  height: 280px;
  background: #FFFFFF;
  padding: 6px;
  box-shadow: 0px 2px 4px 0px rgba(158, 173, 191, 0.39);
  margin-bottom: 12px;
  &>span{
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 16px;
    display: block;
    width: 100%;
    text-align: center;
  }
}
.img-block{
  width: 150px;
  height: 230px;
  margin-bottom: 12px;
}
</style>
